import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { EnhancedHelpModule } from '@flyfreely-portal-ui/enhanced-help';
import { SharedUiModule } from '@flyfreely-portal-ui/ui';
import { ValidationModule } from '@flyfreely-portal-ui/validation';
import { NgSelectModule } from '@ng-select/ng-select';
import { AgGridAngular } from 'ag-grid-angular';
import { Angulartics2Module } from 'angulartics2';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { PaginationModule } from 'ngx-bootstrap/pagination';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { ColumnTemplateDirective } from './column-template.directive';
import { ColumnPickerHeader } from './data-table/column-picker-header.component';
import { DataTable } from './data-table/data-table.component';
import { LinkCellRenderer } from './data-table/link-cell-renderer.component';
import { RowActionsCellRenderer } from './data-table/row-actions-cell-renderer.component';
import { TableFloatingFilter } from './data-table/table-floating-filter.component';
import { TableHeaderComponent } from './data-table/table-header.component';
import { TemplateCellRenderer } from './data-table/template-cell-renderer.component';
import { FlyFreelyTable } from './dynamic-table/flyfreely-table.component';
import { RowActionsDirective } from './row-actions.directive';
import { RowSelector } from './static-table/row-selector.component';
import { StaticTable } from './static-table/static-table.component';
import { TableAsyncSelection } from './table-async-selection/table-async-selection.component';

/**
 * The portal's table components: `static-table` (the bootstrap table most
 * screens use), `data-table` (its AG Grid based successor, taking the same
 * configuration; see docs/tables.md) and the legacy dynamic
 * `flyfreely-table`, with the `columnTemplate` and `rowActions` directives
 * they all consume.
 */
@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        ValidationModule,
        Angulartics2Module,
        SharedUiModule,
        TooltipModule,
        NgSelectModule,
        PopoverModule,
        EnhancedHelpModule,
        PaginationModule,
        BsDatepickerModule,
        AgGridAngular
    ],
    providers: [],
    bootstrap: [],
    declarations: [
        FlyFreelyTable,
        StaticTable,
        ColumnTemplateDirective,
        RowActionsDirective,
        RowSelector,
        TableAsyncSelection,
        DataTable,
        TemplateCellRenderer,
        TableFloatingFilter,
        TableHeaderComponent,
        ColumnPickerHeader,
        RowActionsCellRenderer,
        LinkCellRenderer
    ],
    exports: [
        FlyFreelyTable,
        StaticTable,
        DataTable,
        ColumnTemplateDirective,
        RowActionsDirective
    ]
})
export class FlyFreelyTableModule {}
